module.exports = __webpack_public_path__ + "assets/3fe05437ea9f407adaf4d18747f82f5f.png";